import api from './api';

/**
 * Fetch all payment information records (admin endpoint)
 */
export const fetchPaymentInformation = async () => {
  const response = await api.get('/admin/payment-information');
  return response.data;
};

/**
 * Create a new payment information record
 * @param {Object} data
 * @param {string} data.account_name
 * @param {string} data.account_number
 * @param {string} data.bank_name
 * @param {boolean} data.is_active
 */
export const createPaymentInformation = async (data) => {
  const response = await api.post('/admin/payment-information', data);
  return response.data;
};

/**
 * Update an existing payment information record
 * @param {number} id
 * @param {Object} data
 */
export const updatePaymentInformation = async (id, data) => {
  const response = await api.put(`/admin/payment-information/${id}`, data);
  return response.data;
};

